import { clone } from '@jack-henry/frontend-utils/functions';
import { SuspendUserChallengeModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../shared';

const defaultCompanyUserAuthSuspension: SuspendUserChallengeModelDto = {
    id: 0,
};

export class CompanyUserAuthSuspension extends DomainEntity<SuspendUserChallengeModelDto> {
    constructor(dto = clone(defaultCompanyUserAuthSuspension)) {
        super(dto);
    }

    public get utcSuspendEndTime() {
        return this.dto.utcSuspendEndTime;
    }

    public get localSuspendEndTime() {
        return this.dto.localSuspendEndTime;
    }

    public get updatedBy() {
        return this.dto.updatedBy;
    }

    public get updatedDate() {
        return this.dto.updatedDate;
    }

    public createDefault(): this {
        return new CompanyUserAuthSuspension(defaultCompanyUserAuthSuspension) as this;
    }
}
